var _g, _path, _path2, _path3, _g2, _g3, _g4, _g5, _path4, _g6, _g7, _g8, _g9, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g10, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRohbau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 373,
    viewBox: "0 0 457 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Rohbau"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.812 371.69L0.225586 235.369L0.264184 216.112L30.4178 206.281L236.812 316.285L267.156 350.977L236.812 371.69Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M236.817 372.242L0.229492 235.646V233.107L236.817 369.848V372.242Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M456.774 245.496L236.816 372.243L236.812 330.297L431.513 215.58L456.759 225.905L456.774 245.496Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.229492 216.163L236.812 353.451L456.76 225.905L220.033 101.071L0.229492 216.163Z",
    fill: "#65813F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M195.586 183.014C196.331 213.638 236.272 227.414 242.788 232.979C249.304 238.544 279.772 253.63 308.48 242.812C362.398 268.406 420.83 207.659 420.83 207.659L298.972 143.221C298.972 143.221 194.842 152.39 195.586 183.014Z",
    fill: "#7A6957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 18",
    d: "M53.6536 188.133L226.889 286.831L194.853 305.177L20.4005 205.598L53.6536 188.133Z",
    fill: "#64605F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 19",
    d: "M302.513 132.686L129.277 231.383L152.458 245.461L326.911 145.883L302.513 132.686Z",
    fill: "#64605F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 412",
    d: "M336.93 180.322L342.673 178.435L393.963 205.618L354.335 226.896L336.93 180.322Z",
    fill: "black",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 413",
    d: "M327.113 243.881L370.641 218.734L384.234 210.892L393.947 205.683L409.947 214.432L348.241 235.992L327.113 243.881Z",
    fill: "black",
    fillOpacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 414",
    d: "M281.424 243.76L292.426 237.567L296.37 235.336L304.359 230.729L317.081 237.567L292.883 241.676L281.424 243.76Z",
    fill: "black",
    fillOpacity: 0.12
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Neubau"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Boden",
    d: "M240.736 165.007H364.832V219.1L325.058 230.767L240.736 219.1V165.007Z",
    fill: "#A07C42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 415",
    d: "M228.359 208.262L270.62 183.678L284.212 175.836L304.036 165.109L320.036 173.858L271.756 193.029L228.359 208.262Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 416",
    d: "M235.048 205.852L272.063 192.92L273.07 192.519L279.536 189.93L295.918 199.106L284.976 233.425L235.048 205.852Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wall4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M304.375 126.028L224.827 171.636V210.88L304.375 165.272V126.028Z",
    fill: "#92733E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M304.375 126.028L224.827 171.636V210.88L304.375 165.272V126.028Z",
    fill: "#846437"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wall5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 428",
    d: "M229.6 173.925L304.375 130.969V128.028L227.479 172.045L229.6 173.925Z",
    fill: "#CBAE75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.752 159.439L301.458 189.402V191.788L249.849 162.297L249.752 159.439Z",
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.752 159.439L301.458 189.402V191.788L249.752 162.297L249.752 159.439Z",
    fill: "#D6B472"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1_2",
    d: "M304.375 126.029L383.924 172.167V211.167L304.375 165.272V126.029Z",
    fill: "#92733E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3",
    d: "M304.375 126.029L383.924 171.901L381.802 172.962L304.375 128.415V126.029Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 427",
    d: "M304.375 128.029L383.924 173.901L381.802 175.507L304.375 130.96V128.029Z",
    fill: "#DBBD83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4",
    d: "M229.6 171.371L304.375 128.415V126.028L227.479 170.045L229.6 171.371Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 426",
    d: "M304.375 165.361V128.37L308.313 152.276L310.536 168.948L304.375 165.361Z",
    fill: "black",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.677 171.901L325.323 142.561V140.347L272.556 170.31L274.677 171.901Z",
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.677 171.901L325.323 142.561V140.347L272.556 170.31L274.677 171.901Z",
    fill: "#D6B472"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4_2",
    d: "M243.123 206.637L257.972 215.388V218.304L239.676 207.698L243.123 206.637Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8",
    d: "M247.1 188.872V209.024L244.979 210.615V188.076L247.1 188.872Z",
    fill: "#E3C58B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Balken_Animated"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 417"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.68 191.763L359.182 162.164V159.613L326.768 175.401L306.68 189.576L305.397 190.241L306.68 191.763Z",
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.68 191.763L359.182 162.164V159.613L326.768 175.401L306.68 189.576L305.397 190.241L306.68 191.763Z",
    fill: "#D6B472"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 419",
    d: "M303.491 187.774V189.864L306.68 191.769V189.572L306.134 187.805L303.491 187.774Z",
    fill: "#DBBD83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 418",
    d: "M356.338 157.994L303.484 187.769L306.68 189.596L359.188 159.624L356.338 157.994Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Seil",
    x: 332.618,
    y: 127.935,
    width: 1.99079,
    height: 44.3748,
    fill: "#565656"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wall1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.571 204.251L224.827 171.636V210.88L281.571 243.76V204.251ZM244.979 188.341L257.707 195.732V218.039L244.979 210.703V188.341Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2_2",
    d: "M224.827 204.781L281.571 236.335V243.76L224.827 210.88V204.781Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3_2",
    d: "M227.478 170.045L281.571 200.804V204.516L224.827 171.636L227.478 170.045Z",
    fill: "#F4D18E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wall2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3_3",
    d: "M281.571 204.516L304.375 191.258V230.767L281.571 243.76V204.516Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4_3",
    d: "M281.571 236.6L304.375 223.608V230.767L281.571 243.76V236.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5_2",
    d: "M281.572 200.804L304.375 187.811V191.258L281.572 204.516V200.804Z",
    fill: "#F4D18E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wall3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.179 204.251L304.375 191.16V230.767L327.179 243.76V204.251Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.179 204.251L304.375 191.16V230.767L327.179 243.76V204.251Z",
    fill: "#B6B4AC"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4_4",
    d: "M327.179 236.601L304.375 223.608V230.767L327.179 243.76V236.601Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4_5",
    d: "M250.547 157.317L327.179 200.539V204.251L248.161 158.908L250.547 157.317Z",
    fill: "#F4D18E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wall4_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2_3",
    d: "M383.923 205.046L327.179 236.335V243.76L383.923 211.145V205.046Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4_6",
    d: "M381.006 170.31L327.179 200.539V204.251L383.923 171.901L381.006 170.31Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 6_2",
    d: "M324.262 137.961L269.904 168.454L270.699 171.371L327.179 139.552L324.262 137.961Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 363.241,
    y: 186.22,
    width: 3.18193,
    height: 29.1677,
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.241 214.327L367.288 215.492L348.922 225.833L347.331 223.077L363.241 214.327Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.241 214.327L367.288 215.492L348.922 225.833L347.331 223.077L363.241 214.327Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.241 214.327L367.288 215.492L348.922 225.833L347.331 223.077L363.241 214.327Z",
    fill: "#F4D18E"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 343.088,
    y: 196.296,
    width: 3.18193,
    height: 22.8038,
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10",
    x: 375.438,
    y: 178.795,
    width: 3.18193,
    height: 24.3948,
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.088 213.463L347.136 214.628L328.77 224.969L327.179 222.213L343.088 213.463Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.088 213.463L347.136 214.628L328.77 224.969L327.179 222.213L343.088 213.463Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.088 213.463L347.136 214.628L328.77 224.969L327.179 222.213L343.088 213.463Z",
    fill: "#F4D18E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.438 194.902L377.824 195.501L367.218 202.764L365.627 200.008L375.438 194.902Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.438 194.902L377.824 195.501L367.218 202.764L365.627 200.008L375.438 194.902Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.438 194.902L377.824 195.501L367.218 202.764L365.627 200.008L375.438 194.902Z",
    fill: "#F4D18E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.179 204.251L383.923 171.901V211.145L327.179 243.76V204.251ZM365.362 186.75L348.922 196.259V224.403L365.362 215.085V186.75ZM368.544 185.079L377.559 179.856V195.42L368.544 200.539V185.079ZM345.21 198.417L336.194 203.64V219.1L345.21 213.981V198.417Z",
    fill: "#8D8A83"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Kran"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M188.656 145.242L221.205 164.074L253.753 145.242L221.205 126.411L188.656 145.242Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Kranschatten",
    d: "M226.138 126.019L249.354 116.389L279.349 132.316L221.057 157.864L226.138 126.019Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M199.505 132.686L221.203 120.131L242.901 132.686L221.203 145.24L199.505 132.686Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M199.505 132.686V145.24L221.203 157.794V145.24L199.505 132.686Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M221.203 157.794L242.901 145.24V132.686L221.203 145.24V157.794Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M221.203 103.023V100.231L238.076 110.114V112.785L221.203 103.023Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M221.203 100.231L223.616 98.8347L238.076 107.589V110.114L221.203 100.231Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M218.791 121.524V52.4755L221.203 53.8717V122.92L218.791 121.524Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M223.616 121.524V52.4755L221.203 53.8717V122.92L223.616 121.524Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M221.203 81.4259V78.6325L238.076 88.3994V91.1874L221.203 81.4259Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M221.203 78.6325L223.616 77.2363L238.076 85.9908V88.5171L221.203 78.6325Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M221.204 103.023V100.231L204.333 110.114V112.785L221.204 103.023Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M221.204 100.231L218.791 98.8347L204.333 107.589V110.114L221.204 100.231Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M221.204 81.4259V78.6325L204.333 88.5172V91.1874L221.204 81.4259Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M221.204 78.6325L218.791 77.2363L204.333 85.9908V88.5171L221.204 78.6325Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M199.505 132.687V63.6382L201.917 65.0344V134.083L199.505 132.687Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M204.333 132.687V63.6382L201.917 65.0344V134.083L204.333 132.687Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M218.791 143.846V74.7972L221.203 76.1935V145.242L218.791 143.846Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M223.617 143.844L223.588 72.0107L221.172 73.407L221.202 145.24L223.617 143.844Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M238.076 132.687V63.6382L240.49 65.0344V134.083L238.076 132.687Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M242.901 132.687V63.6382L240.489 65.0344V134.083L242.901 132.687Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M201.917 114.185V111.393L218.791 121.276V123.946L201.917 114.185Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M201.917 111.393L204.332 109.997L218.791 118.751V121.277L201.917 111.393Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M201.917 92.5893V89.7958L218.791 99.6806V102.351L201.917 92.5893Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M201.917 89.7968L204.332 88.4007L218.791 97.1552V99.6815L201.917 89.7968Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M240.49 114.304V111.512L223.617 121.395V124.065L240.49 114.304Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M240.49 111.511L238.077 110.113L223.617 118.868V121.394L240.49 111.511Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M240.49 92.7071V89.9147L223.617 99.7995V102.469L240.49 92.7071Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M240.49 89.9146L238.077 88.5184L223.617 97.273V99.7993L240.49 89.9146Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M175.329 27.3878V24.5954L338.125 118.78L338.126 121.548L175.329 27.3878Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M175.329 24.5956L177.744 23.1983L340.54 117.367L338.127 118.764L175.329 24.5956Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M177.746 28.8229L177.71 26.0133L158.49 37.1567L158.488 39.9252L177.746 28.8229Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M180.158 24.5956L177.745 23.1983L156.364 35.7337L158.602 37.1775L180.158 24.5956Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M309.792 105.158L309.756 102.349L290.289 113.638L290.288 116.406L309.792 105.158Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M311.957 101.074L309.543 99.6783L287.876 112.241L290.289 113.637L311.957 101.074Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M279.605 87.7453L279.571 84.9356L260.351 96.0792L260.349 98.8467L279.605 87.7453Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M282.018 83.5163L279.605 82.1202L257.937 94.6816L260.351 96.0789L282.018 83.5163Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M240.489 65.0735L240.455 62.2638L221.233 73.4075L221.232 76.176L240.489 65.0735Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M242.901 60.847L240.488 59.4498L218.819 72.0122L221.233 73.4084L242.901 60.847Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M221.204 53.9197L221.147 51.1003L201.918 62.2483L201.917 65.0331L221.204 53.9197Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M223.586 49.6859L221.172 48.2899L199.505 60.8522L201.918 62.2484L223.586 49.6859Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M156.107 35.7335L158.521 34.3373L321.318 128.506L318.903 129.903L156.107 35.7335Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M177.716 48.3292V25.9132L199.459 13.3162V35.732L177.716 48.3292Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M215.791 28.3315L196.985 17.4994L197.004 14.707L215.79 25.563L215.791 28.3315Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M156.107 38.5258V35.7323L318.904 129.902V132.686L156.107 38.5258Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M243.488 44.3765L215.79 28.3674V25.575L243.487 41.6078L243.488 44.3765Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M156.107 35.7601V13.3939L158.521 14.7901V37.1563L156.107 35.7601Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M160.935 35.7601V13.3939L158.521 14.7901V37.1563L160.935 35.7601Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M175.296 24.6047L175.304 2.18445L177.745 3.59795V26.0203L175.296 24.6047Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M180.158 24.624V2.20056L177.745 3.59783V26.0202L180.158 24.624Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M180.192 5.00837L180.158 2.19867L158.521 14.7903V17.5189L180.192 5.00837Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M180.158 2.19887L177.707 0.781006L156.107 13.3943L158.521 14.7906L180.158 2.19887Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M199.519 60.8783V38.5112L201.932 39.9084V62.2745L199.519 60.8783Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M204.346 60.8783V38.5112L201.931 39.9084V62.2745L204.346 60.8783Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M218.708 49.7236L218.715 27.3022L221.156 28.7158V51.1393L218.708 49.7236Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M223.568 49.7418V27.3195L221.156 28.7156V51.139L223.568 49.7418Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M223.568 30.0778V27.3158L201.931 39.9086V42.636L223.568 30.0778Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M223.569 27.3161L221.118 25.8993L199.519 38.5117L201.932 39.9089L223.569 27.3161Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M218.819 72.062V49.6958L221.231 51.092V73.4582L218.819 72.062Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M223.644 72.062V49.6958L221.23 51.092V73.4582L223.644 72.062Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M238.008 60.9047L238.014 38.4846L240.455 39.8981V62.3205L238.008 60.9047Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M242.867 60.9247V38.5012L240.454 39.8984V62.3209L242.867 60.9247Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M242.904 41.3092L242.868 38.4995L221.23 51.0912V53.8198L242.904 41.3092Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M242.868 38.4995L240.419 37.0818L218.819 49.6951L221.232 51.0913L242.868 38.4995Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M277.17 63.8473L240.495 42.6697L240.514 39.8762L277.169 61.0797L277.17 63.8473Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M257.933 94.6771V72.3109L260.346 73.7071V96.0733L257.933 94.6771Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M262.762 94.6771V72.3109L260.346 73.7071V96.0733L262.762 94.6771Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M277.125 83.5213L277.131 61.1011L279.573 62.5146V84.937L277.125 83.5213Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M281.985 83.5411V61.1176L279.573 62.5148V84.9373L281.985 83.5411Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M282.021 63.9259L281.985 61.1163L260.346 73.708V76.4365L282.021 63.9259Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M281.985 61.1163L279.535 59.6984L257.933 72.3118L260.346 73.708L281.985 61.1163Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M307.304 81.2808L279.606 65.2716V62.4792L307.303 78.5121L307.304 81.2808Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M340.576 120.176L340.541 117.366L318.904 129.901V132.686L340.576 120.176Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M340.54 117.366L338.09 115.948L316.49 128.505L318.903 129.901L340.54 117.366Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M287.874 112.216V89.8502L290.289 91.2464V113.613L287.874 112.216Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M292.701 112.216V89.8502L290.288 91.2464V113.613L292.701 112.216Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M307.065 101.061L307.072 78.6407L309.51 80.0532V102.477L307.065 101.061Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M311.927 101.08V78.6566L309.51 80.0528V102.476L311.927 101.08Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M311.961 81.4648L311.926 78.6551L290.288 91.2469V93.9744L311.961 81.4648Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M311.927 78.654L309.476 77.2363L287.874 89.8496L290.289 91.2458L311.927 78.654Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M316.49 128.506V106.139L318.904 107.536V129.902L316.49 128.506Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M321.318 128.506V106.139L318.904 107.536V129.902L321.318 128.506Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M335.682 117.35L335.689 94.929L338.126 96.3425V118.766L335.682 117.35Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M340.541 117.369V94.9459L338.126 96.3421V118.765L340.541 117.369Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M309.547 82.857L309.738 79.9196L338.125 96.3571L338.126 99.1247L309.547 82.857Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M175.329 2.17233L177.744 0.776123L340.54 94.944L338.127 96.3402L175.329 2.17233Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M156.107 16.1525V13.3601L318.904 107.529V110.313L156.107 16.1525Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M156.107 13.3592L158.521 11.9631L321.318 106.132L318.903 107.528L156.107 13.3592Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M340.576 97.7525L340.541 94.9428L318.904 107.536V110.263L340.576 97.7525Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M340.54 94.9422L338.09 93.5255L316.49 106.138L318.903 107.535L340.54 94.9422Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M156.107 13.3939V38.4368L177.713 50.902V25.8905L156.107 13.3939Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M177.714 25.8904L156.107 13.3938L177.746 0.776123L199.401 13.3602L177.714 25.8904Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M185.148 11.3935C185.123 10.672 184.922 9.96766 184.562 9.3425C184.202 8.71734 183.693 8.19056 183.082 7.80861C182.415 7.42273 181.964 7.41171 181.658 7.57235L181.659 7.57053L181.61 7.59865L181.598 7.60593L179.594 8.76599L181.016 9.00354C181.04 9.725 181.242 10.4294 181.602 11.0545C181.962 11.6797 182.47 12.2065 183.082 12.5884L182.49 13.9936L184.549 12.8009L184.567 12.7904L184.571 12.7882L184.57 12.7881C185.147 12.4148 185.148 11.3935 185.148 11.3935Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M178.95 10.1985C178.95 10.1985 178.951 7.80867 181.017 9.00358C181.628 9.38551 182.136 9.91226 182.497 10.5374C182.857 11.1625 183.058 11.8669 183.083 12.5883C183.083 12.5883 183.083 14.9781 181.017 13.7832C180.405 13.4013 179.897 12.8745 179.537 12.2494C179.176 11.6242 178.975 10.9199 178.95 10.1985Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M180.479 10.4491L176.766 12.598L177.863 14.5024L181.576 12.3535L180.479 10.4491Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M180.258 10.9552C180.258 10.9552 180.259 10.0781 181.016 10.5167C181.24 10.6568 181.426 10.8502 181.558 11.0796C181.69 11.3091 181.764 11.5676 181.773 11.8324C181.773 11.8324 181.773 12.7095 181.016 12.2709C180.792 12.1307 180.605 11.9374 180.473 11.708C180.341 11.4785 180.267 11.22 180.258 10.9552Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M199.519 38.501V16.1348L201.932 17.531V39.8972L199.519 38.501Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M204.346 38.501V16.1348L201.931 17.531V39.8972L204.346 38.501Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M218.708 27.3468L218.715 4.92664L221.156 6.33908V28.7625L218.708 27.3468Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M223.568 27.3654V4.94196L221.156 6.33816V28.7616L223.568 27.3654Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M223.568 7.7006V4.93945L201.931 17.5313V20.2587L223.568 7.7006Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M223.569 4.94012L221.118 3.5224L199.519 16.1356L201.932 17.5319L223.569 4.94012Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M221.156 9.13143V6.33795L238.028 16.1048V18.8929L221.156 9.13143Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M221.156 6.33817L223.569 4.94196L240.418 14.7056L238.026 16.223L221.156 6.33817Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M218.819 49.6856V27.3195L221.231 28.7156V51.0818L218.819 49.6856Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M223.644 49.6856V27.3195L221.23 28.7156V51.0818L223.644 49.6856Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M238.008 38.5297L238.014 16.1084L240.455 17.5219V39.9453L238.008 38.5297Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M242.867 38.5499V16.1265L240.454 17.5227V39.9461L242.867 38.5499Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M242.904 18.9325L242.868 16.1228L221.23 28.7155V31.4431L242.904 18.9325Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M242.868 16.123L240.419 14.7062L218.819 27.3196L221.232 28.7157L242.868 16.123Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M201.931 20.3234V17.5309L218.819 27.3185V30.1628L201.931 20.3234Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M201.931 17.5317L204.226 16.1755L221.117 25.9748L218.884 27.3656L201.931 17.5317Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M217.756 6.98463C217.732 6.26316 217.531 5.55881 217.171 4.93364C216.811 4.30847 216.302 3.7817 215.691 3.39975C215.024 3.01387 214.574 3.00283 214.268 3.16347L214.269 3.16167L214.22 3.18977L214.207 3.19707L212.204 4.35712L213.626 4.59469C213.65 5.31616 213.852 6.02053 214.212 6.64569C214.572 7.27086 215.08 7.79764 215.691 8.1796L215.1 9.58484L217.158 8.39207L217.176 8.38156L217.18 8.3794L217.179 8.37932C217.756 8.00593 217.756 6.98463 217.756 6.98463Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M211.561 5.79009C211.561 5.79009 211.561 3.40029 213.627 4.59519C214.239 4.97712 214.747 5.50387 215.107 6.129C215.467 6.75414 215.669 7.45846 215.693 8.17989C215.693 8.17989 215.693 10.5697 213.627 9.3748C213.016 8.99287 212.507 8.46612 212.147 7.84099C211.787 7.21585 211.585 6.51152 211.561 5.79009Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M213.078 6.03798L209.364 8.18683L210.461 10.0911L214.175 7.94224L213.078 6.03798Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M212.869 6.54683C212.869 6.54683 212.869 5.66999 213.626 6.10842C213.851 6.24855 214.037 6.44182 214.169 6.67119C214.301 6.90056 214.375 7.15898 214.384 7.42368C214.384 7.42368 214.384 8.30053 213.626 7.8621C213.402 7.72197 213.216 7.52869 213.084 7.29932C212.952 7.06996 212.878 6.81153 212.869 6.54683Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M211.561 10.5904C211.537 9.86904 211.335 9.16477 210.975 8.53967C210.615 7.91456 210.107 7.38783 209.496 7.00592C208.829 6.62007 208.378 6.60904 208.072 6.76966L208.073 6.76786L208.025 6.79598L208.012 6.80327L206.009 7.96321L207.431 8.20075C207.455 8.92214 207.656 9.62644 208.016 10.2515C208.376 10.8766 208.885 11.4034 209.496 11.7853L208.904 13.1904L210.962 11.9977L210.98 11.9872L210.984 11.9851L210.983 11.985C211.561 11.6116 211.561 10.5904 211.561 10.5904Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M205.365 9.39712C205.365 9.39712 205.365 7.00727 207.43 8.20219C208.041 8.58413 208.549 9.11088 208.909 9.73602C209.27 10.3612 209.471 11.0655 209.495 11.7869C209.495 11.7869 209.495 14.1768 207.43 12.9819C206.819 12.5999 206.31 12.0732 205.95 11.448C205.59 10.8229 205.389 10.1186 205.365 9.39712Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M236.644 18.6233C236.62 17.9019 236.419 17.1975 236.059 16.5723C235.699 15.9472 235.191 15.4204 234.58 15.0385C233.913 14.6526 233.463 14.6416 233.157 14.8022L233.158 14.8004L233.11 14.8285L233.097 14.8358L231.095 15.9958L232.516 16.2334C232.54 16.9549 232.741 17.6592 233.101 18.2844C233.461 18.9095 233.969 19.4363 234.58 19.8182L233.988 21.2235L236.046 20.0307L236.064 20.0202L236.068 20.0181L236.067 20.018C236.644 19.6446 236.644 18.6233 236.644 18.6233Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M230.452 17.431C230.452 17.431 230.452 15.0409 232.516 16.2359C233.127 16.6179 233.635 17.1447 233.995 17.77C234.355 18.3952 234.556 19.0996 234.581 19.8211C234.581 19.8211 234.581 22.2113 232.516 21.0162C231.905 20.6342 231.397 20.1074 231.037 19.4822C230.677 18.8569 230.476 18.1525 230.452 17.431Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M231.968 17.6775L228.253 19.8263L229.351 21.7306L233.065 19.5817L231.968 17.6775Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M231.757 18.1866C231.757 18.1866 231.757 17.3095 232.516 17.748C232.74 17.8882 232.927 18.0816 233.059 18.311C233.191 18.5405 233.265 18.799 233.274 19.0638C233.274 19.0638 233.274 19.941 232.516 19.5024C232.291 19.3622 232.105 19.1689 231.972 18.9394C231.84 18.71 231.766 18.4514 231.757 18.1866Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M230.452 22.2304C230.427 21.509 230.226 20.8047 229.866 20.1795C229.506 19.5544 228.997 19.0276 228.386 18.6456C227.719 18.2598 227.268 18.2487 226.962 18.4094L226.963 18.4076L226.915 18.4357L226.902 18.443L224.898 19.603L226.32 19.8406C226.345 20.562 226.546 21.2663 226.906 21.8915C227.266 22.5167 227.774 23.0434 228.386 23.4254L227.794 24.8306L229.853 23.6378L229.871 23.6273L229.875 23.6252L229.874 23.6251C230.451 23.2517 230.452 22.2304 230.452 22.2304Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M224.254 21.0377C224.254 21.0377 224.254 18.6479 226.319 19.8428C226.931 20.2247 227.439 20.7515 227.799 21.3766C228.159 22.0018 228.36 22.7061 228.385 23.4275C228.385 23.4275 228.385 25.8173 226.319 24.6224C225.708 24.2405 225.2 23.7137 224.84 23.0886C224.479 22.4635 224.278 21.7591 224.254 21.0377Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M337.748 97.6543C337.723 96.9328 337.522 96.2284 337.162 95.6033C336.802 94.9781 336.293 94.4513 335.682 94.0693C335.015 93.6835 334.564 93.6725 334.258 93.8331L334.259 93.8313L334.21 93.8594L334.198 93.8667L332.194 95.0267L333.616 95.2643C333.641 95.9858 333.842 96.6901 334.202 97.3153C334.562 97.9405 335.07 98.4673 335.682 98.8492L335.09 100.254L337.149 99.0617L337.167 99.0512L337.171 99.049L337.17 99.0489C337.747 98.6755 337.748 97.6543 337.748 97.6543Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M331.553 96.4593C331.553 96.4593 331.553 94.0695 333.618 95.2644C334.229 95.6463 334.737 96.173 335.097 96.7982C335.457 97.4233 335.658 98.1276 335.682 98.849C335.682 98.849 335.682 101.239 333.618 100.044C333.007 99.662 332.499 99.1352 332.139 98.5101C331.778 97.885 331.577 97.1807 331.553 96.4593Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M333.068 96.7086L329.355 98.8574L330.452 100.762L334.166 98.6128L333.068 96.7086Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M332.859 97.216C332.859 97.216 332.86 96.3388 333.618 96.7774C333.843 96.9176 334.029 97.111 334.161 97.3404C334.294 97.5699 334.368 97.8284 334.377 98.0932C334.377 98.0932 334.377 98.9705 333.618 98.5319C333.394 98.3917 333.207 98.1983 333.075 97.9688C332.942 97.7394 332.868 97.4808 332.859 97.216Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M331.553 101.26C331.528 100.539 331.327 99.8346 330.967 99.2095C330.607 98.5843 330.098 98.0576 329.487 97.6757C328.82 97.2898 328.369 97.2788 328.063 97.4394L328.064 97.4376L328.016 97.4657L328.003 97.473L325.999 98.633L327.421 98.8705C327.446 99.5919 327.647 100.296 328.007 100.921C328.367 101.547 328.876 102.073 329.487 102.455L328.895 103.86L330.954 102.668L330.972 102.657L330.976 102.655L330.975 102.655C331.552 102.282 331.553 101.26 331.553 101.26Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M325.355 100.066C325.355 100.066 325.355 97.6766 327.421 98.8714C328.032 99.2534 328.54 99.7801 328.9 100.405C329.26 101.03 329.461 101.735 329.486 102.456C329.486 102.456 329.486 104.846 327.421 103.651C326.809 103.269 326.301 102.742 325.941 102.117C325.581 101.492 325.379 100.788 325.355 100.066Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M175.286 15.9016C175.286 15.9016 177.304 11.8922 179.161 11.205C181.017 10.5179 209.889 5.79402 212.75 7.2801C215.611 8.76619 224.175 14.6403 231.094 18.8938C238.013 23.1472 333.617 93.5973 333.617 100.045V130.111",
    stroke: "#565656",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M178.95 14.9995C178.926 14.278 178.725 13.5737 178.365 12.9485C178.005 12.3234 177.497 11.7966 176.886 11.4146C176.219 11.0287 175.769 11.0177 175.463 11.1784L175.464 11.1765L175.415 11.2047L175.403 11.2119L173.401 12.372L174.822 12.6096C174.846 13.331 175.047 14.0354 175.407 14.6605C175.767 15.2857 176.275 15.8125 176.886 16.1944L176.294 17.5996L178.352 16.4069L178.37 16.3964L178.374 16.3942L178.373 16.3941C178.95 16.0208 178.95 14.9995 178.95 14.9995Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M172.757 13.8056C172.757 13.8056 172.757 11.4158 174.821 12.6107C175.432 12.9926 175.94 13.5194 176.3 14.1445C176.66 14.7697 176.861 15.474 176.885 16.1955C176.885 16.1955 176.885 18.5853 174.821 17.3904C174.21 17.0085 173.703 16.4817 173.343 15.8565C172.983 15.2314 172.782 14.5271 172.757 13.8056Z",
    fill: "#B3B2AA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M165.901 176.447C171.155 178.615 171.155 182.191 165.901 184.452C159.983 186.666 152.981 186.666 147.064 184.452C141.811 182.285 141.811 178.708 147.064 176.447C152.981 174.233 159.983 174.233 165.901 176.447Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M156.191 180.29L153.389 163.457C153.457 164.144 153.114 164.667 152.362 165.14C150.936 166.036 148.574 166.16 147.085 165.373C146.312 164.965 145.928 164.427 145.935 163.863L145.934 163.863L144.245 181.428C144.157 182.418 144.784 183.396 146.117 184.1C148.548 185.385 152.407 185.221 154.735 183.757C156.291 182.779 156.768 181.441 156.191 180.29Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M143.261 131.595C151.05 131.595 157.364 138.107 157.364 146.139C157.364 154.171 151.05 160.683 143.261 160.683C135.471 160.683 129.157 154.171 129.157 146.139C129.157 138.107 135.471 131.595 143.261 131.595Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M151.223 142.773C146.581 145.317 139.06 145.317 134.418 142.773C132.303 141.643 131.186 140.117 130.951 138.646C130.716 140.512 131.833 142.377 134.418 143.79C139.06 146.334 146.581 146.334 151.223 143.79C153.751 142.377 154.926 140.511 154.691 138.646C154.455 140.173 153.34 141.64 151.223 142.773Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M152.468 152.985C147.138 155.847 138.503 155.847 133.173 152.985C130.744 151.713 129.463 149.997 129.193 148.343C128.922 150.442 130.205 152.539 133.173 154.129C138.503 156.991 147.138 156.991 152.468 154.129C155.37 152.539 156.719 150.441 156.449 148.343C156.179 150.059 154.898 151.711 152.468 152.985Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M155.602 138.646C163.391 138.646 169.705 145.158 169.705 153.191C169.705 161.223 163.391 167.735 155.602 167.735C147.812 167.735 141.498 161.223 141.498 153.191C141.498 145.158 147.812 138.646 155.602 138.646Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M164.316 149.825C159.502 152.369 151.702 152.369 146.888 149.825C144.694 148.695 143.537 147.168 143.293 145.698C143.049 147.564 144.207 149.429 146.888 150.842C151.702 153.386 159.502 153.386 164.316 150.842C166.937 149.429 168.155 147.563 167.912 145.698C167.667 147.224 166.511 148.692 164.316 149.825Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M165.69 160.037C160.36 162.899 151.725 162.899 146.395 160.037C143.966 158.765 142.685 157.048 142.415 155.394C142.144 157.494 143.427 159.591 146.395 161.181C151.725 164.043 160.36 164.043 165.69 161.181C168.592 159.591 169.941 157.492 169.671 155.394C169.401 157.111 168.12 158.763 165.69 160.037Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M143.261 150.987C148.616 150.987 152.957 155.526 152.957 161.124C152.957 166.722 148.616 171.261 143.261 171.261C137.906 171.261 133.565 166.722 133.565 161.124C133.565 155.526 137.906 150.987 143.261 150.987Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M148.733 159.371C145.467 161.279 140.174 161.279 136.908 159.371C135.419 158.523 134.633 157.378 134.468 156.276C134.302 157.675 135.088 159.074 136.908 160.134C140.174 162.042 145.467 162.042 148.733 160.134C150.512 159.074 151.339 157.675 151.174 156.276C151.008 157.42 150.223 158.521 148.733 159.371Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M150.108 166.423C146.326 168.33 140.197 168.33 136.415 166.423C134.691 165.575 133.782 164.43 133.59 163.328C133.398 164.727 134.308 166.125 136.415 167.185C140.197 169.093 146.326 169.093 150.108 167.185C152.167 166.125 153.125 164.726 152.933 163.328C152.741 164.472 151.833 165.573 150.108 166.423Z",
    fill: "#D9D9D0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M140.518 213.838C145.772 216.006 145.772 219.583 140.518 221.844C134.6 224.058 127.598 224.058 121.681 221.844C116.428 219.677 116.428 216.099 121.681 213.838C127.598 211.624 134.6 211.624 140.518 213.838Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M130.807 217.682L128.006 200.848C128.074 201.535 127.731 202.059 126.979 202.532C125.553 203.428 123.191 203.552 121.702 202.765C120.929 202.357 120.545 201.819 120.552 201.255L120.551 201.255L118.862 218.819C118.774 219.81 119.401 220.787 120.733 221.491C123.165 222.776 127.024 222.613 129.352 221.149C130.908 220.171 131.385 218.833 130.807 217.682Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M117.878 168.986C125.667 168.986 131.981 175.498 131.981 183.531C131.981 191.563 125.667 198.075 117.878 198.075C110.088 198.075 103.774 191.563 103.774 183.531C103.774 175.498 110.088 168.986 117.878 168.986Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M125.84 180.165C121.198 182.709 113.677 182.709 109.035 180.165C106.919 179.034 105.803 177.508 105.568 176.038C105.333 177.904 106.449 179.769 109.035 181.182C113.677 183.726 121.198 183.726 125.84 181.182C128.368 179.769 129.543 177.903 129.308 176.038C129.072 177.564 127.957 179.032 125.84 180.165Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M127.085 190.377C121.755 193.239 113.12 193.239 107.79 190.377C105.361 189.105 104.079 187.388 103.81 185.734C103.539 187.833 104.822 189.931 107.79 191.521C113.12 194.383 121.755 194.383 127.085 191.521C129.987 189.931 131.336 187.832 131.066 185.734C130.796 187.451 129.515 189.102 127.085 190.377Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M130.219 176.038C138.008 176.038 144.322 182.55 144.322 190.582C144.322 198.615 138.008 205.127 130.219 205.127C122.429 205.127 116.115 198.615 116.115 190.582C116.115 182.55 122.429 176.038 130.219 176.038Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M138.933 187.217C134.119 189.76 126.319 189.76 121.505 187.217C119.311 186.086 118.154 184.56 117.91 183.09C117.666 184.956 118.824 186.82 121.505 188.234C126.319 190.777 134.119 190.777 138.933 188.234C141.554 186.82 142.772 184.955 142.529 183.09C142.284 184.616 141.128 186.084 138.933 187.217Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M140.307 197.429C134.977 200.29 126.342 200.29 121.012 197.429C118.583 196.157 117.302 194.44 117.032 192.786C116.761 194.885 118.044 196.983 121.012 198.573C126.342 201.435 134.977 201.435 140.307 198.573C143.209 196.983 144.558 194.884 144.288 192.786C144.018 194.503 142.737 196.154 140.307 197.429Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M117.878 188.379C123.233 188.379 127.574 192.917 127.574 198.515C127.574 204.114 123.233 208.652 117.878 208.652C112.523 208.652 108.182 204.114 108.182 198.515C108.182 192.917 112.523 188.379 117.878 188.379Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M123.35 196.763C120.084 198.67 114.791 198.67 111.525 196.763C110.036 195.915 109.25 194.77 109.085 193.667C108.919 195.067 109.705 196.465 111.525 197.525C114.791 199.433 120.084 199.433 123.35 197.525C125.129 196.465 125.956 195.066 125.791 193.667C125.625 194.812 124.84 195.913 123.35 196.763Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M124.725 203.814C120.943 205.722 114.814 205.722 111.032 203.814C109.308 202.966 108.398 201.822 108.207 200.719C108.015 202.119 108.925 203.517 111.032 204.577C114.814 206.485 120.943 206.485 124.725 204.577C126.784 203.517 127.742 202.118 127.55 200.719C127.358 201.864 126.45 202.965 124.725 203.814Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Absperrung"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_160",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.599 269.128L145.237 276.423L173.69 259.889L161.052 252.594L132.599 269.128Z",
    fill: "#DBDBDB"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M161.975 247.589L161.521 247.204L158.559 245.639L159.012 246.023L161.975 247.589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M162.813 243.829L162.359 243.444L158.559 245.639L159.012 246.023L162.813 243.829Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M159.012 246.023L161.975 247.589L162.813 243.829L159.012 246.023Z",
    fill: "#C43817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M159.991 250.486L159.538 250.101L154.989 247.698L155.443 248.083L159.991 250.486Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M155.443 248.083L159.991 250.486L161.526 249.601L161.975 247.589L159.012 246.023L155.443 248.083Z",
    fill: "#642020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M159.012 246.023L158.559 245.639L154.989 247.698L155.443 248.083L159.012 246.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M156.971 252.23L156.518 251.845L151.971 249.441L152.424 249.826L156.971 252.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M152.424 249.826L156.971 252.23L159.991 250.486L155.443 248.083L152.424 249.826Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M155.443 248.083L154.989 247.698L151.971 249.441L152.424 249.826L155.443 248.083Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M153.402 254.29L152.948 253.905L148.403 251.501L148.857 251.886L153.402 254.29Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M152.424 249.826L151.971 249.441L148.403 251.501L148.857 251.886L152.424 249.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M148.857 251.886L153.402 254.29L156.971 252.23L152.424 249.826L148.857 251.886Z",
    fill: "#642020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M150.383 256.034L149.929 255.649L145.384 253.245L145.838 253.63L150.383 256.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M145.838 253.63L150.383 256.034L153.402 254.29L148.857 251.886L145.838 253.63Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M148.856 251.886L148.403 251.501L145.384 253.245L145.838 253.63L148.856 251.886Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M146.815 258.094L146.362 257.709L141.815 255.305L142.269 255.69L146.815 258.094Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M142.269 255.69L146.815 258.094L150.383 256.034L145.838 253.63L142.269 255.69Z",
    fill: "#642020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M145.838 253.63L145.384 253.245L141.815 255.305L142.269 255.69L145.838 253.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M143.797 259.836L143.343 259.451L138.795 257.049L139.25 257.433L143.797 259.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M142.269 255.69L141.815 255.305L138.795 257.049L139.25 257.434L142.269 255.69Z",
    fill: "#EAB8B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M139.25 257.434L143.797 259.836L146.815 258.094L142.268 255.69L139.25 257.434Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M136.858 260.114L135.906 264.392L140.227 261.896L136.858 260.114Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M136.858 260.115L136.405 259.73L135.452 264.008L135.906 264.392L136.858 260.115Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M140.227 261.896L139.774 261.511L136.405 259.73L136.858 260.115L140.227 261.896Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M137.191 258.621L136.858 260.114L140.227 261.896L143.797 259.836L139.25 257.434L137.191 258.621Z",
    fill: "#642020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M139.25 257.433L138.795 257.049L136.738 258.236L137.192 258.621L139.25 257.433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M137.191 258.621L136.738 258.236L136.405 259.73L136.858 260.115L137.191 258.621Z",
    fill: "#D9D9D9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M163.626 240.239L163.173 239.854L160.21 238.287L160.664 238.674L163.626 240.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M164.465 236.479L164.01 236.094L160.21 238.287L160.664 238.674L164.465 236.479Z",
    fill: "#EAB8B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M160.664 238.674L163.626 240.239L164.465 236.479L160.664 238.674Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M161.643 243.136L161.19 242.751L156.641 240.349L157.095 240.734L161.643 243.136Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M157.095 240.734L161.643 243.136L163.177 242.251L163.626 240.239L160.664 238.674L157.095 240.734Z",
    fill: "#642020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M160.664 238.674L160.21 238.287L156.641 240.349L157.095 240.734L160.664 238.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M158.623 244.88L158.169 244.495L153.622 242.091L154.076 242.476L158.623 244.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M154.076 242.476L158.623 244.88L161.643 243.136L157.095 240.733L154.076 242.476Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M157.095 240.734L156.641 240.349L153.622 242.091L154.076 242.476L157.095 240.734Z",
    fill: "#EAB8B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M155.053 246.94L154.6 246.555L150.055 244.151L150.508 244.536L155.053 246.94Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M154.076 242.476L153.622 242.091L150.055 244.151L150.508 244.536L154.076 242.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M150.508 244.536L155.053 246.94L158.623 244.88L154.076 242.476L150.508 244.536Z",
    fill: "#642020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M152.035 248.684L151.581 248.299L147.036 245.894L147.489 246.28L152.035 248.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M147.49 246.28L152.035 248.684L155.054 246.94L150.508 244.536L147.49 246.28Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M150.508 244.536L150.055 244.151L147.036 245.894L147.489 246.28L150.508 244.536Z",
    fill: "#EAB8B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M148.467 250.744L148.013 250.359L143.467 247.955L143.92 248.34L148.467 250.744Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M143.92 248.34L148.467 250.744L152.035 248.684L147.489 246.28L143.92 248.34Z",
    fill: "#642020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M147.489 246.28L147.036 245.894L143.467 247.955L143.92 248.34L147.489 246.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M145.448 252.486L144.995 252.101L140.446 249.699L140.9 250.084L145.448 252.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M143.92 248.34L143.467 247.955L140.446 249.699L140.9 250.084L143.92 248.34Z",
    fill: "#EAB8B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M140.9 250.084L145.448 252.486L148.467 250.744L143.92 248.34L140.9 250.084Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M138.51 252.765L137.557 257.042L141.879 254.546L138.51 252.765Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M138.51 252.765L138.056 252.38L137.104 256.658L137.557 257.042L138.51 252.765Z",
    fill: "#9E1811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M141.879 254.546L141.425 254.161L138.056 252.38L138.51 252.765L141.879 254.546Z",
    fill: "#EC682B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M138.843 251.271L138.51 252.765L141.879 254.546L145.448 252.486L140.9 250.084L138.843 251.271Z",
    fill: "#642020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M140.9 250.084L140.446 249.699L138.39 250.886L138.843 251.271L140.9 250.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M138.843 251.271L138.389 250.886L138.056 252.38L138.51 252.765L138.843 251.271Z",
    fill: "#D9D9D9"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M139.731 249.712L139.276 249.325L134.959 268.701L135.413 269.086L139.731 249.712Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M141.084 248.929L140.631 248.545L139.276 249.325L139.731 249.711L141.084 248.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M139.731 249.711L135.413 269.086L136.767 268.306L141.084 248.929L139.731 249.711Z",
    fill: "#CDCCCC"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M163.997 235.7L163.543 235.315L159.225 254.692L159.68 255.076L163.997 235.7Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M165.351 234.918L164.898 234.533L163.543 235.315L163.997 235.7L165.351 234.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M163.997 235.7L159.68 255.076L161.033 254.294L165.352 234.918L163.997 235.7Z",
    fill: "#CDCCCC"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M140.332 250.082L139.883 249.966L145.187 274.679L145.635 274.795L140.332 250.082Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M141.685 249.3L141.238 249.184L139.883 249.966L140.332 250.082L141.685 249.3Z",
    fill: "#EEEDED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M140.332 250.082L145.634 274.795L146.989 274.013L141.685 249.3L140.332 250.082Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M164.598 236.073L164.15 235.957L169.454 260.67L169.902 260.785L164.598 236.073Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M165.952 235.29L165.505 235.175L164.15 235.957L164.598 236.072L165.952 235.29Z",
    fill: "#EEEDED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M164.598 236.073L169.902 260.785L171.256 260.003L165.952 235.29L164.598 236.073Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M166.924 237.63L166.476 237.515L162.675 239.709L163.123 239.825L166.924 237.63Z",
    fill: "#D97B79"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M163.123 239.825L162.675 239.709L167.505 242.312L167.953 242.427L163.123 239.825Z",
    fill: "#EC682B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M163.123 239.825L167.953 242.427L166.923 237.63L163.123 239.825Z",
    fill: "#CC382C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M159.555 241.885L159.108 241.769L166.518 245.762L166.967 245.878L159.555 241.885Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M159.555 241.885L166.967 245.878L168.503 244.991L167.953 242.427L163.123 239.825L159.555 241.885Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M163.123 239.825L162.675 239.709L159.108 241.769L159.555 241.885L163.123 239.825Z",
    fill: "#EEEDED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M156.536 243.627L156.089 243.511L163.5 247.506L163.949 247.622L156.536 243.627Z",
    fill: "#EC682B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M156.536 243.627L163.949 247.622L166.967 245.878L159.555 241.885L156.536 243.627Z",
    fill: "#CC382C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M159.555 241.885L159.108 241.769L156.089 243.511L156.536 243.627L159.555 241.885Z",
    fill: "#D97B79"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M152.969 245.687L152.52 245.573L159.932 249.566L160.379 249.682L152.969 245.687Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M152.969 245.687L160.379 249.682L163.949 247.622L156.536 243.627L152.969 245.687Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M156.536 243.627L156.089 243.511L152.52 245.573L152.969 245.687L156.536 243.627Z",
    fill: "#EEEDED"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M149.948 247.431L149.499 247.315L156.913 251.308L157.36 251.424L149.948 247.431Z",
    fill: "#EC682B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M152.968 245.687L152.52 245.573L149.499 247.315L149.948 247.431L152.968 245.687Z",
    fill: "#D97B79"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M149.948 247.431L157.36 251.424L160.379 249.682L152.968 245.687L149.948 247.431Z",
    fill: "#CC382C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M149.948 247.431L149.499 247.315L145.933 249.375L146.381 249.491L149.948 247.431Z",
    fill: "#EEEDED"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M146.381 249.491L145.933 249.375L153.344 253.369L153.793 253.484L146.381 249.491Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M146.38 249.491L153.793 253.484L157.361 251.424L149.948 247.431L146.38 249.491Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M143.36 251.235L142.913 251.119L150.324 255.112L150.772 255.228L143.36 251.235Z",
    fill: "#EC682B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M143.36 251.235L150.773 255.228L153.793 253.484L146.381 249.491L143.36 251.235Z",
    fill: "#CC382C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M146.38 249.491L145.933 249.375L142.913 251.119L143.36 251.235L146.38 249.491Z",
    fill: "#D97B79"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M141.712 254.327L141.264 254.213L146.757 257.172L147.205 257.288L141.712 254.327Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M141.712 254.327L142.883 259.783L147.205 257.288L141.712 254.327Z",
    fill: "#CC382C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M141.712 254.327L141.264 254.213L142.434 259.667L142.883 259.783L141.712 254.327Z",
    fill: "#9E1811"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M141.303 252.422L141.712 254.327L147.205 257.288L150.773 255.228L143.36 251.235L141.303 252.422Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M143.36 251.235L142.913 251.119L140.856 252.306L141.303 252.422L143.36 251.235Z",
    fill: "#EEEDED"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M141.303 252.422L140.856 252.306L141.264 254.213L141.712 254.327L141.303 252.422Z",
    fill: "#D9D9D9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M168.85 246.934L168.403 246.82L164.602 249.012L165.05 249.128L168.85 246.934Z",
    fill: "#D97B79"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M165.05 249.128L164.602 249.012L169.432 251.615L169.88 251.731L165.05 249.128Z",
    fill: "#EC682B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M165.05 249.128L169.88 251.731L168.85 246.934L165.05 249.128Z",
    fill: "#CC382C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M161.482 251.188L161.035 251.074L168.445 255.067L168.894 255.183L161.482 251.188Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M161.482 251.188L168.894 255.183L170.43 254.296L169.88 251.731L165.05 249.128L161.482 251.188Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M165.05 249.128L164.602 249.012L161.035 251.074L161.482 251.188L165.05 249.128Z",
    fill: "#EEEDED"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M158.463 252.932L158.016 252.816L165.427 256.809L165.876 256.925L158.463 252.932Z",
    fill: "#EC682B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M158.463 252.932L165.876 256.925L168.894 255.183L161.482 251.188L158.463 252.932Z",
    fill: "#CC382C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M161.482 251.188L161.035 251.074L158.016 252.816L158.463 252.932L161.482 251.188Z",
    fill: "#D97B79"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M154.894 254.992L154.447 254.876L161.859 258.871L162.306 258.985L154.894 254.992Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M154.894 254.992L162.306 258.985L165.876 256.925L158.463 252.932L154.894 254.992Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M158.463 252.932L158.016 252.816L154.447 254.876L154.894 254.992L158.463 252.932Z",
    fill: "#EEEDED"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M151.875 256.736L151.426 256.62L158.84 260.613L159.287 260.729L151.875 256.736Z",
    fill: "#EC682B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M154.894 254.992L154.447 254.876L151.426 256.62L151.875 256.736L154.894 254.992Z",
    fill: "#D97B79"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M151.875 256.736L159.288 260.729L162.306 258.985L154.894 254.992L151.875 256.736Z",
    fill: "#CC382C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M151.875 256.736L151.426 256.62L147.86 258.68L148.307 258.794L151.875 256.736Z",
    fill: "#EEEDED"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M148.307 258.794L147.86 258.68L155.271 262.673L155.72 262.789L148.307 258.794Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M148.307 258.794L155.72 262.789L159.288 260.729L151.875 256.736L148.307 258.794Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M145.287 260.538L144.84 260.423L152.251 264.417L152.699 264.533L145.287 260.538Z",
    fill: "#EC682B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M145.287 260.538L152.699 264.533L155.72 262.789L148.307 258.794L145.287 260.538Z",
    fill: "#CC382C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M148.307 258.794L147.86 258.68L144.84 260.423L145.287 260.538L148.307 258.794Z",
    fill: "#D97B79"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M143.639 263.632L143.191 263.516L148.684 266.477L149.132 266.592L143.639 263.632Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M143.639 263.632L144.81 269.088L149.132 266.591L143.639 263.632Z",
    fill: "#CC382C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M143.639 263.632L143.191 263.516L144.361 268.972L144.81 269.088L143.639 263.632Z",
    fill: "#9E1811"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M143.23 261.727L143.639 263.632L149.132 266.591L152.699 264.533L145.287 260.538L143.23 261.727Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M145.287 260.538L144.84 260.423L142.781 261.611L143.23 261.727L145.287 260.538Z",
    fill: "#EEEDED"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M143.23 261.727L142.781 261.611L143.191 263.516L143.639 263.632L143.23 261.727Z",
    fill: "#D9D9D9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M139.877 249.973L138.79 249.341L138.791 249.76L139.879 250.392L139.877 249.973Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M166.357 234.649L165.27 234.017L138.79 249.341L139.877 249.973L166.357 234.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M139.877 249.973L139.879 250.392L166.359 235.069L166.357 234.649L139.877 249.973Z",
    fill: "#EEEDED"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M142.355 247.25C142.53 247.146 142.687 247.013 142.82 246.859C142.989 246.665 143.127 246.446 143.231 246.211C143.347 245.961 143.41 245.689 143.415 245.413C143.429 245.282 143.407 245.15 143.352 245.03C143.298 244.91 143.212 244.807 143.105 244.73L143.766 245.114C143.873 245.19 144.021 245.091 144.076 245.211C144.131 245.331 144.191 245.652 144.178 245.783C144.172 246.059 144.139 246.382 144.024 246.633C143.92 246.868 143.729 247.13 143.56 247.324C143.427 247.479 143.233 247.67 143.058 247.774C142.95 247.853 142.759 247.863 142.626 247.876C142.493 247.889 142.23 247.933 142.108 247.876L141.598 247.324C141.719 247.38 141.853 247.403 141.986 247.39C142.119 247.377 142.247 247.329 142.355 247.25Z",
    fill: "#FFD91C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M141.169 245.78C141.309 245.464 141.495 245.171 141.722 244.911C141.9 244.703 142.111 244.525 142.347 244.385C142.492 244.279 142.663 244.214 142.842 244.196C143.021 244.179 143.202 244.209 143.365 244.285L144.026 244.669C143.862 244.593 143.681 244.651 143.502 244.669C143.323 244.686 143.177 244.718 143.032 244.824C142.797 244.965 142.645 245.14 142.466 245.348C142.24 245.608 142.14 245.859 142 246.175C141.845 246.512 141.73 246.84 141.722 247.211C141.704 247.387 141.757 247.526 141.83 247.687C141.903 247.848 141.856 248.051 142 248.154L141.34 247.77C141.195 247.668 141.08 247.529 141.007 247.367C140.934 247.206 140.904 247.028 140.922 246.852C140.93 246.482 141.014 246.117 141.169 245.78Z",
    fill: "#FFD91C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M142.788 245.069C142.479 245.27 142.222 245.541 142.037 245.86C141.853 246.18 141.747 246.538 141.728 246.906C141.729 247.581 142.207 247.854 142.795 247.515C143.104 247.314 143.361 247.043 143.546 246.723C143.73 246.404 143.836 246.046 143.856 245.677C143.854 245.002 143.376 244.73 142.788 245.069Z",
    fill: "#F49823"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M144.442 245.585C144.416 246.08 144.273 246.562 144.026 246.991C143.778 247.42 143.432 247.785 143.017 248.055C142.228 248.51 141.585 248.144 141.583 247.236C141.609 246.742 141.751 246.26 141.999 245.832C142.247 245.403 142.592 245.039 143.007 244.769C143.797 244.313 144.44 244.677 144.442 245.585ZM143.015 247.634C143.325 247.433 143.582 247.162 143.766 246.842C143.95 246.523 144.057 246.165 144.076 245.797C144.074 245.121 143.596 244.849 143.008 245.188C142.699 245.389 142.442 245.66 142.258 245.98C142.073 246.299 141.967 246.657 141.948 247.025C141.95 247.701 142.428 247.973 143.015 247.634Z",
    fill: "#EDBF07"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M161.22 236.166C161.395 236.061 161.552 235.929 161.685 235.774C161.854 235.58 161.993 235.362 162.097 235.127C162.212 234.876 162.275 234.604 162.281 234.328C162.294 234.197 162.272 234.065 162.218 233.945C162.163 233.825 162.078 233.722 161.97 233.646L162.631 234.03C162.739 234.106 162.912 234.107 162.966 234.227C163.021 234.347 162.955 234.581 162.941 234.712C162.936 234.988 162.959 235.314 162.843 235.565C162.739 235.8 162.564 236.046 162.395 236.24C162.262 236.394 162.083 236.519 161.908 236.624C161.8 236.702 161.622 236.804 161.489 236.817C161.356 236.83 161.225 236.81 161.104 236.754L160.463 236.24C160.584 236.296 160.719 236.319 160.852 236.306C160.985 236.293 161.112 236.244 161.22 236.166Z",
    fill: "#FFD91C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M160.035 234.696C160.174 234.38 160.361 234.087 160.587 233.826C160.766 233.618 160.977 233.441 161.212 233.301C161.358 233.195 161.529 233.13 161.708 233.112C161.887 233.094 162.067 233.125 162.23 233.2L162.891 233.584C162.728 233.509 162.536 233.567 162.357 233.584C162.178 233.602 162.063 233.649 161.895 233.749C161.66 233.889 161.473 234.07 161.294 234.278C161.067 234.538 160.947 234.758 160.808 235.074C160.652 235.41 160.574 235.778 160.566 236.149C160.549 236.325 160.514 236.483 160.587 236.644C160.661 236.805 160.721 236.967 160.866 237.069L160.205 236.686C160.06 236.583 159.946 236.444 159.872 236.283C159.799 236.122 159.77 235.944 159.788 235.768C159.795 235.397 159.879 235.032 160.035 234.696Z",
    fill: "#FFD91C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M161.654 233.985C161.345 234.186 161.087 234.457 160.903 234.776C160.719 235.095 160.612 235.454 160.593 235.822C160.595 236.497 161.073 236.769 161.661 236.43C161.97 236.229 162.227 235.958 162.411 235.639C162.596 235.32 162.702 234.961 162.721 234.593C162.719 233.918 162.241 233.645 161.654 233.985Z",
    fill: "#F49823"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M163.308 234.501C163.282 234.996 163.139 235.477 162.891 235.907C162.643 236.336 162.298 236.7 161.882 236.97C161.093 237.426 160.451 237.06 160.448 236.152C160.474 235.657 160.617 235.176 160.864 234.747C161.112 234.318 161.458 233.954 161.873 233.684C162.663 233.228 163.305 233.593 163.308 234.501ZM161.881 236.549C162.19 236.349 162.447 236.077 162.632 235.758C162.816 235.439 162.922 235.08 162.941 234.712C162.94 234.037 162.462 233.765 161.874 234.104C161.565 234.305 161.308 234.576 161.123 234.895C160.939 235.214 160.833 235.573 160.813 235.941C160.815 236.616 161.293 236.889 161.881 236.549V236.549Z",
    fill: "#EDBF07"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Stra\xC3\x9Fenschild"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_292",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M190.844 193.182L185.299 189.981C184.731 189.687 184.1 189.533 183.46 189.533C182.819 189.534 182.189 189.687 181.62 189.982L176.112 193.183C175.859 193.283 175.643 193.457 175.49 193.682C175.338 193.906 175.258 194.172 175.259 194.444C175.26 194.715 175.343 194.98 175.498 195.204C175.652 195.427 175.87 195.599 176.124 195.697L181.668 198.898C182.236 199.192 182.867 199.346 183.508 199.345C184.148 199.345 184.779 199.192 185.347 198.897L190.855 195.696C191.108 195.596 191.324 195.422 191.477 195.197C191.629 194.972 191.71 194.707 191.708 194.435C191.707 194.163 191.624 193.899 191.47 193.675C191.315 193.452 191.097 193.28 190.844 193.182H190.844Z",
    fill: "#DBDBDB"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M190.689 194.41L185.181 197.611C184.663 197.875 184.09 198.013 183.508 198.013C182.927 198.013 182.353 197.875 181.835 197.611L176.291 194.41C176.098 194.325 175.932 194.189 175.809 194.017C175.686 193.846 175.611 193.645 175.592 193.435L175.59 194.109C175.609 194.319 175.684 194.52 175.807 194.692C175.929 194.863 176.096 194.999 176.289 195.084L181.833 198.285C182.351 198.549 182.924 198.687 183.506 198.687C184.087 198.687 184.661 198.549 185.179 198.285L190.687 195.084C190.876 194.999 191.04 194.865 191.161 194.696C191.281 194.527 191.355 194.329 191.374 194.122L191.377 193.448C191.358 193.655 191.284 193.853 191.163 194.022C191.042 194.191 190.879 194.325 190.689 194.41Z",
    fill: "#C7C6C6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M190.677 192.473C190.88 192.541 191.056 192.67 191.181 192.843C191.306 193.016 191.374 193.224 191.376 193.438C191.377 193.651 191.311 193.86 191.188 194.034C191.065 194.209 190.89 194.34 190.688 194.411L185.18 197.612C184.662 197.876 184.088 198.013 183.507 198.013C182.925 198.013 182.352 197.876 181.834 197.612L176.29 194.411C176.087 194.343 175.911 194.213 175.786 194.04C175.66 193.867 175.593 193.659 175.591 193.446C175.59 193.232 175.656 193.023 175.779 192.849C175.902 192.674 176.077 192.543 176.279 192.473L181.787 189.272C182.305 189.008 182.879 188.87 183.46 188.87C184.042 188.87 184.615 189.008 185.133 189.272L190.677 192.473Z",
    fill: "#E9E8E8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M183.483 193.109C183.413 193.109 183.344 193.102 183.28 193.089C183.215 193.076 183.156 193.056 183.107 193.032C183.058 193.008 183.018 192.979 182.992 192.948C182.965 192.916 182.951 192.882 182.951 192.848V170.161H184.016V192.848C184.016 192.917 183.959 192.983 183.86 193.032C183.76 193.081 183.624 193.109 183.483 193.109Z",
    fill: "#C7C6C6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M182.951 177.164L184.015 177.885V172.069L182.951 171.758V177.164Z",
    fill: "#949494"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M195.3 177.069L186.57 155.266C186.549 155.214 186.528 155.163 186.505 155.112C186.316 154.682 186.063 154.283 185.754 153.929C185.506 153.64 185.213 153.394 184.887 153.199C184.687 153.054 184.453 152.965 184.207 152.939C183.962 152.914 183.714 152.954 183.49 153.056L182.768 153.475C182.992 153.374 183.24 153.334 183.485 153.359C183.731 153.384 183.965 153.474 184.165 153.618C184.491 153.813 184.784 154.06 185.032 154.348C185.341 154.703 185.594 155.102 185.783 155.532C185.806 155.582 185.827 155.634 185.848 155.686L194.578 177.488C195.076 178.731 194.878 179.739 194.278 180.087L195 179.668C195.6 179.319 195.798 178.312 195.3 177.069Z",
    fill: "#9E1811"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M184.164 153.618C184.934 154.108 185.525 154.833 185.848 155.686L194.578 177.488C195.365 179.454 194.414 180.83 192.881 179.945L175.328 169.811C173.794 168.925 172.854 166.457 173.65 165.405L182.475 153.738C182.859 153.23 183.512 153.242 184.164 153.618Z",
    fill: "#CC382C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M183.68 155.754L174.908 167.351L192.358 177.426L183.68 155.754Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M180.541 164.804L182.295 167.252L182.485 170.586C182.499 170.827 182.338 170.932 182.135 170.815C182.042 170.754 181.963 170.673 181.903 170.579C181.844 170.484 181.805 170.378 181.79 170.267L181.498 167.575L180.914 166.675L179.489 169.067C179.43 169.168 179.308 169.183 179.178 169.107L179.081 169.052C178.955 168.977 178.857 168.864 178.8 168.729C178.743 168.594 178.73 168.445 178.764 168.302L180.541 164.804Z",
    fill: "#3B3B3B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M184.074 162.271C184.316 162.428 184.518 162.64 184.662 162.89C184.807 163.14 184.89 163.42 184.905 163.708C184.904 164.238 184.528 164.449 184.069 164.183C183.827 164.026 183.626 163.814 183.481 163.564C183.337 163.315 183.254 163.034 183.239 162.746C183.241 162.219 183.615 162.005 184.074 162.271Z",
    fill: "#3B3B3B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M182.953 163.021L183.991 164.688L183.651 167.711L184.612 168.704L185.368 168.609L186.14 166.417L190.146 175.44L182.858 171.233L184.117 168.765L184.194 168.756L183.328 167.88L182.945 167.661L183.112 165.672L182.345 166.93L180.871 164.818L181.802 163.473L181.282 163.105L180.564 164.061L179.9 163.457L180.905 161.901L182.953 163.021Z",
    fill: "#3B3B3B"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "LochNEU"
  }, /*#__PURE__*/React.createElement("path", {
    id: "RechtsWand",
    d: "M234.448 247.905L316.774 293.911L285.573 316.268L234.448 289.068V247.905Z",
    fill: "#806D5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Boden_2",
    d: "M284.308 314.896L234.748 288.862L187.08 316.136L233.082 343.159L284.308 314.896Z",
    fill: "#7A6957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LinksWand",
    d: "M234.448 247.905L153.622 294.54L187.124 316.182L234.448 289.068V247.905Z",
    fill: "#574A3D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Schatten"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SchattenEck",
    d: "M234.448 289.062V247.905L239.815 280.486L242.845 293.951L234.448 289.062Z",
    fill: "black",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 78",
    d: "M274.695 318.734L269.763 323.269L224.974 297.086L230.691 293.559L274.695 318.734Z",
    fill: "#70604F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 80",
    d: "M244.847 297.27L239.182 300.358L238.281 299.711L243.981 296.762L244.847 297.27Z",
    fill: "#70604F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 81",
    d: "M263.994 274.723V299.102H262.169V275.436L263.994 274.723Z",
    fill: "#70604F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 82",
    d: "M270.291 278.384V302.763H268.466V279.097L270.291 278.384Z",
    fill: "#70604F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 79",
    d: "M284.602 312.476L277.395 316.541L232.786 290.409L237.384 286.285L284.602 312.476Z",
    fill: "#70604F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rohr-Gelb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rohr-Hinten"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 116",
    cx: 220.385,
    cy: 277.166,
    rx: 3.46191,
    ry: 4.18665,
    transform: "rotate(30.0381 220.385 277.166)",
    fill: "#4C4136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 617",
    d: "M222.469 273.842L221.806 278.005L218.592 280.626L219.854 281.429L280.684 316.096L288.269 311.347L223.757 274.581L222.469 273.842Z",
    fill: "#E9D100"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 115",
    cx: 220.543,
    cy: 277.236,
    rx: 3.05986,
    ry: 3.90858,
    transform: "rotate(30.0381 220.543 277.236)",
    fill: "#E9D100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rohr-Klein"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 117",
    rx: 0.978321,
    ry: 1.18313,
    transform: "matrix(-0.865693 0.500576 0.500576 0.865693 269.499 278.249)",
    fill: "#4C4136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 618",
    d: "M250.592 288.014L252.41 288.999L269.927 279.011L269.021 277.511L250.592 288.014Z",
    fill: "#E9D100"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 116_2",
    rx: 0.686201,
    ry: 0.876534,
    transform: "matrix(-0.865693 0.500576 0.500576 0.865693 269.499 278.249)",
    fill: "#E9D100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Verteiler"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 117_2",
    cx: 245.016,
    cy: 291.152,
    rx: 3.54534,
    ry: 4.72334,
    transform: "rotate(29.6723 245.016 291.152)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 18",
    rx: 1.47149,
    ry: 1.60339,
    transform: "matrix(-0.988361 -0.152129 -0.152129 0.988361 251.402 288.945)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 80_2",
    d: "M252.877 288.945H249.93V291.152H252.877V288.945Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 618_2",
    d: "M242.564 295.175L254.907 302.199L259.323 293.832L247.27 287.004L242.564 295.175Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 116_3",
    cx: 257.124,
    cy: 298.01,
    rx: 3.54534,
    ry: 4.72334,
    transform: "rotate(29.6723 257.124 298.01)",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rohr-Vorne"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 618_3",
    d: "M288.269 311.347L280.684 316.096L255.612 301.814L259.794 294.869L288.269 311.347Z",
    fill: "#E9D100"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 116_4",
    cx: 257.715,
    cy: 298.343,
    rx: 3.06578,
    ry: 4.05069,
    transform: "rotate(30.0381 257.715 298.343)",
    fill: "#E9D100"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rohr-Blau"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rohr-Hinten_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 116_5",
    cx: 201.507,
    cy: 287.881,
    rx: 3.46191,
    ry: 4.18665,
    transform: "rotate(30.0381 201.507 287.881)",
    fill: "#4C4136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 617_2",
    d: "M203.592 284.556L202.928 288.72L199.714 291.34L200.977 292.144L261.807 326.811L269.392 322.061L204.88 285.296L203.592 284.556Z",
    fill: "#6792FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 115_2",
    cx: 201.665,
    cy: 287.951,
    rx: 3.05986,
    ry: 3.90858,
    transform: "rotate(30.0381 201.665 287.951)",
    fill: "#6792FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rohr-Klein_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 117_3",
    rx: 0.978321,
    ry: 1.18313,
    transform: "matrix(-0.865693 0.500576 0.500576 0.865693 263.267 274.642)",
    fill: "#4C4136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 618_4",
    d: "M225.482 295.122L227.301 296.106L263.706 275.4L262.8 273.9L225.482 295.122Z",
    fill: "#6792FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 116_6",
    rx: 0.686201,
    ry: 0.876534,
    transform: "matrix(-0.865693 0.500576 0.500576 0.865693 263.267 274.642)",
    fill: "#6792FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Verteiler_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 117_4",
    cx: 219.907,
    cy: 298.26,
    rx: 3.54534,
    ry: 4.72334,
    transform: "rotate(29.6723 219.907 298.26)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 18_2",
    rx: 1.47149,
    ry: 1.60339,
    transform: "matrix(-0.988361 -0.152129 -0.152129 0.988361 226.293 296.053)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 80_3",
    d: "M227.767 296.053H224.821V298.26H227.767V296.053Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 618_5",
    d: "M217.454 302.282L229.798 309.306L234.214 300.94L222.161 294.111L217.454 302.282Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 116_7",
    cx: 232.015,
    cy: 305.118,
    rx: 3.54534,
    ry: 4.72334,
    transform: "rotate(29.6723 232.015 305.118)",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rohr-Vorne_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 618_6",
    d: "M263.16 318.454L255.575 323.204L230.502 308.922L234.684 301.976L263.16 318.454Z",
    fill: "#6792FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 116_8",
    cx: 232.606,
    cy: 305.45,
    rx: 3.06578,
    ry: 4.05069,
    transform: "rotate(30.0381 232.606 305.45)",
    fill: "#6792FF"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "SchattenEck_2",
    d: "M189.901 314.492L153.695 294.527L234.444 247.91L240.66 284.253L216.776 304.504L198.298 319.382L189.901 314.492Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 76",
    d: "M254.295 332.964V334.226L210.015 309.948L210.924 309.217L254.295 332.964Z",
    fill: "#70604F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 77",
    d: "M248.551 336.344V337.605L205.256 313.781L206.095 313.109L248.551 336.344Z",
    fill: "#70604F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rohr-Schwarz"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 76_2",
    d: "M192.278 301.022L253.034 334.52V335.781L191.719 301.933L192.278 301.022Z",
    fill: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 117_5",
    cx: 192.012,
    cy: 301.488,
    rx: 0.419005,
    ry: 0.535224,
    transform: "rotate(30.0381 192.012 301.488)",
    fill: "#3B3B3B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rohr-Schwarz_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 76_3",
    d: "M186.76 305.237L187.319 304.326L244.675 335.95L243.672 336.655L186.76 305.237Z",
    fill: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 117_6",
    cx: 187.053,
    cy: 304.792,
    rx: 0.419005,
    ry: 0.535224,
    transform: "rotate(30.0381 187.053 304.792)",
    fill: "#3B3B3B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "GrasLinks",
    d: "M153.722 294.581L236.601 339.898V345.703L153.722 298.031V294.581Z",
    fill: "#65813F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GrasRechts",
    d: "M316.783 293.94L236.603 339.895V345.542L316.783 298.511V293.94Z",
    fill: "#65813F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRohbau);
export default __webpack_public_path__ + "static/media/Rohbau.d62829be4a6036fc4026e8f5ac5a6e4d.svg";
export { ForwardRef as ReactComponent };